<p>cm-edit-permission works!</p>
